import type { ReactElement } from 'react';

import classes from './StageBenefits.module.scss';

const StageBenefitsBox: React.FC<{ children: ReactElement }> = ({ children }) => {
  return (
    <div data-testid="stage-benefits-box" className={classes.stageBenefitsBox}>
      {children}
    </div>
  );
};
export default StageBenefitsBox;
